import Vue from 'vue'
import App from './App.vue'

import router from './router'
import store from './store/store'
import i18n from './services/i18n'

import Vuelidate from 'vuelidate'

import './assets/styles/fonts.scss'
Vue.use(Vuelidate)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
